import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    button: {
        width: '200px !important'
    }
}))

export {
  useStyles
}